<template>
  <div :class="{overflow_hidden:popFail}" class="groupBook b_white">
    <template v-if="isEmpty">
      <div class="group_yhq">
        <img v-lazy="`${activityDtl.coverImage}?imageMogr2/thumbnail/120000@`">
      </div>
      <div class="group_me group_item">
        <p class="group_head mar13_b">{{ activity.title }}</p>
        <p class="f14_rem lin_15 gray_3 mar13_b">剩余{{ activityGoods.remainGoodsQuantity }}份</p>
        <p class="group_head mar13_b">活动时间</p>
        <p class="f14_rem lin_15 gray_3">
          {{ activity.startTimeStr }}
          —
          {{ activity.endTimeStr}}
        </p>
      </div>
      <div class="group_item">
        <p class="group_head mar15_b">拼团流程</p>
        <ul class="group_step clear">
          <li>
            <img src="../images/group_step1.png" alt="">
            <p>开团/参团</p>
          </li>
          <li>
            <img src="../images/group_step2.png" alt="">
            <p>分享好友</p>
            <p>邀请参团</p>
          </li>
          <li>
            <img src="../images/group_step3.png" alt="">
            <p>达到目标</p>
            <p>人数</p>
          </li>
          <li>
            <img src="../images/group_step4.png" alt="">
            <p>拼团成功</p>
            <p>等待收货</p>
          </li>
        </ul>
      </div>
      <div class="group_item group_plan_wrap group_plan_item" v-if="inHandGroupList.length">
        <p class="group_head mar15_b">目前进行中的拼团</p>
        <div class="group_plan flex justify_around align_center"
             v-for="(groupList, index) in inHandGroupList" :key="index">
          <ul class="clear">
            <li>
              <div class="relative group_plan_img">
                <span class="group_plan_name">团长</span>
                <img v-lazy="`${groupList.imgUrl}?imageMogr2/thumbnail/120000@`">
              </div>
              <p class="f20_rem mui-ellipsis gray_3">{{ groupList.name }}</p>
            </li>
            <template v-if="groupList.groupDetailList">
              <li v-for="(groupDetail, index) in groupList.groupDetailList" :key="index">
                <div class="relative group_plan_img">
                  <img v-lazy="`${groupDetail.imgUrl}?imageMogr2/thumbnail/120000@`">
                </div>
                <p class="f20_rem mui-ellipsis gray_3">{{ groupDetail.name }}</p>
              </li>
            </template>
            <li>
              <div class="relative group_plan_img">
                <img src="../images/group_plan_more.png" alt="">
              </div>
            </li>
          </ul>
          <div class="group_join gray_3 f10_rem">剩余 <span class="red">{{ groupList.remainPeople }}</span>人即可拼团成功</div>
        </div>
      </div>
      <div class="group_item group_good">
        <p class="group_head mar20_b">商品详情</p>
        <ul>
          <li class="clear" @click="toGoodsDetail(goodsEntity.goodsId)">
            <div class="collect_img relative mui-pull-left">
              <img v-lazy="`${goodsEntity.picUrl}?imageMogr2/thumbnail/120000@`">
            </div>
            <div class="mui-media-body mui-pull-left collect_main">
              <h3 class="f13_rem yahei gray_3 lin_15 mui-ellipsis-2 ">{{ goodsEntity.name }}</h3>
              <div class="box10"></div>
              <p class="red f14_rem fb">拼团价：¥ {{ activityGoods.goodsPrice }}</p>
              <div class="box5"></div>
              <p class="lin_15 f10_rem gray_6">原价：¥ {{ activityGoods.marketPrice }}</p>
            </div>
          </li>
        </ul>
      </div>
      <div class="group_item group_desc" v-if="activityDtl.description">
        <p class="group_head mar20_b">活动规则</p>
        <div v-html="activityDtl.description"> </div>
      </div>
      <div class="box30" v-if="isIos"></div>
      <div class="box70" v-if="isShowBtn"></div>
      <div class="group_me_float" @click="toMyGroup">
        <img src="../images/group_me.png" alt="">
        <span>我的拼团</span>
      </div>
      <div class="group_btn mar20_t">
        <p class="t_center f14_rem white btn_join" v-if="isShowBtn" @click="toOrderSubmit">我要开团¥{{ activityGoods.sponsorPrice }}</p>
      </div>
    </template>
    <div class="mask_block" v-if="popFail"></div>
    <div class="group_pop" v-show="popFail">
      <div class="group_success t_center">
        <div class="box50 flex justify_end align_center direction_column">
          <p class="f16_rem gray_3 lin_24" v-html="verifyResult.msg"></p>
        </div>
        <div class="box20"></div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-if="'401100,401106'.indexOf(verifyResult.code) !== -1" @click="toGoodList">去开团</div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-else-if="'401101'.indexOf(verifyResult.code) !== -1" @click="toGoodList">好的，去开团</div>
        <div class="group_pop_btn white pop_btn_success f16_rem"
             v-else @click="popFailClose">好的</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .group_desc ::v-deep img {
    display: block;
    width: 100%;
  }
  @import './style.scss';
</style>

<script>
import { mapState } from "vuex";
import common from "../../../assets/js/common";

export default {
  name: "groupBook",
  data() {
    return {
      popFail: false,
      activity: {},
      activityDtl: {},
      activityGoods: {},
      inHandGroupList: [],
      goodsEntity: {},
      isEmpty: false,
      isToOrder: false,
      isShowBtn: true,
      verifyResult: {},
      shopId: "",
      isIos: false
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      this.isIos = true;
    }
    const { query } = this.$route;
    if (query.shopId) {
      this.shopId = query.shopId;
    }
    this.getVerifyGroupStatus();
  },
  methods: {
    popFailClose() {
      $(".mask").hide();
      this.popFail = false;
    },
    toMyGroup() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$router.push("/group/myGroup");
    },
    toGoodList() {
      this.$router.push(`/group/goodList?shopId=${this.shopId}`);
    },
    toOrderSubmit() {
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.$store.dispatch("group/goods/getVerifySponsorGroup", {
        goodsId: this.activityGoods.goodsId
      }).then((res) => {
        this.verifyResult = res;
        if (res.code === "0") {
          const orderCartEntity = [{
            goodsId: this.activityGoods.goodsId,
            goodsQuantity: 1,
            fromShopId: this.activity.shopId,
            fundShopId: this.activity.shopId,
            fromCart: 0,
            isYxGroup: 1,
            yxGroupId: ""
          }];
          const goodsInJson = JSON.stringify(orderCartEntity);
          const carts = encodeURIComponent(goodsInJson);
          window.location.href = `${process.env.VUE_APP_APP}mob/order/confirmOrder.do?sources=0&carts=${carts}`;
          return;
        }
        // 失败
        if (res.code === "401108") {
          this.toOrderDetail(res.data.orderId);
        } else {
          this.popFail = true;
        }
      });
    },
    load() {
      this.$store.dispatch("group/goods/queryGroupDetail", {
        goodsId: this.$route.params.goodsId,
        activityId: this.$route.params.activityId
      }).then((res) => {
        if (res.data) {
          this.activity = res.data.activity;
          document.title = this.activity.title;
          this.activityDtl = res.data.activityDtl;
          this.activityGoods = res.data.activityGoods;
          this.goodsEntity = this.activityGoods.goodsEntity;
        }
      });
    },
    queryInHandGroupList() {
      this.$store.dispatch("group/goods/queryInHandGroupList", {
        goodsId: this.$route.params.goodsId,
        activityId: this.$route.params.activityId,
        pageNum: 1,
        pageSize: 3
      }).then((res) => {
        this.inHandGroupList = res.data;
        if (this.inHandGroupList && this.inHandGroupList.length > 0) {
          const find = this.inHandGroupList.find(group => group.sponsorBoId === this.userInfo.id);
          if (find) {
            this.isShowBtn = false;
          }
        }
      });
    },
    getVerifyGroupStatus() {
      this.$store.dispatch("group/goods/getVerifyGroupStatus", {
        activityId: this.$route.params.activityId
      }).then((res) => {
        this.verifyResult = res;
        if (res.code === "0") {
          this.isEmpty = true;
          this.load();
          this.queryInHandGroupList();
        } else {
          $(".mask").show();
          this.popFail = true;
          this.isEmpty = false;
        }
      });
    },
    toOrderDetail(orderId) {
      window.location.href = `${process.env.VUE_APP_APP}mob/order/person/orderDetail.do?orderId=${orderId}`;
    },
    toGoodsDetail(goodsId) {
      window.location.href = `/vm/goodDetails/${goodsId}`;
    }
  }
};
</script>
